/**
 *
 * ErrorMessage
 *
 */

import React, { memo } from 'react';
import { ErrorMessage as FormikErrorMessage } from 'formik';
import PropTypes from 'prop-types';
// import styled from 'styled-components';

function ErrorMessage(props) {
  return (
    <FormikErrorMessage
      name={props.name}
      render={msg => <span className="error-message">{msg}</span>}
    />
  );
}

ErrorMessage.propTypes = {
  name: PropTypes.string,
};

export default memo(ErrorMessage);
